import { useQuery } from "@tanstack/react-query";
import { getSkuCostBreakdown } from "@/helpers/apis";
import { SkuBreakdownParams } from "../types";

export const useSkuCostBreakdown = (params: SkuBreakdownParams, enabled = true) => {
  return useQuery({
    queryKey: [
      "sku-cost-breakdown",
      params.start_date,
      params.end_date,
      params.group_by,
      params.workspace_id,
      params.sortAttribute,
      params.sortOrder,
      // Stable key for the multi-value filter — sorted to avoid order-dependence.
      params.group_by === "product"
        ? [...(params.products ?? [])].sort().join("|")
        : [...(params.sku_names ?? [])].sort().join("|"),
    ],
    queryFn: () => getSkuCostBreakdown(params),
    enabled,
  });
};
